"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeDelayedTask = void 0;
class IkeDelayedTask {
    constructor(func, ms = 0) {
        this.func = func;
        this.ms = ms;
    }
    get isActive() {
        return this.timeoutId != null;
    }
    delay(ms = this.ms) {
        const nextTime = Date.now() + ms;
        // Dont re-make the timeout if the next timeout is within X ms
        if (this.isActive) {
            const diffTime = Math.abs(nextTime - this.nextTime);
            if (diffTime < 5) {
                return;
            }
        }
        this.cancel();
        this.timeoutId = setTimeout(this.func, ms);
        this.nextTime = nextTime;
    }
    run() {
        this.cancel();
        this.func();
    }
    cancel() {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
        this.nextTime = null;
    }
}
exports.IkeDelayedTask = IkeDelayedTask;
//# sourceMappingURL=delayed.task.js.map